import API from 'app/services/role/roleApi'
import { RolePermissionModel } from 'app/models/rolePermissionModel'

/**
 * Role, wspólne dla sześciu miejsc.
 *
 * Slice `roles` czytały: zakładka Role, Użytkownicy, Firmy, edycja użytkownika,
 * edycja firmy — a `postLogin` wołał samo pobranie. Lista jest globalna i pobierana
 * bez parametrów, więc mieści się w jednym kluczu react-query; wszystkie te ekrany
 * widzą tę samą wartość, tak jak wcześniej widziały ten sam slice.
 */
export const ROLES_KEY = ['admin', 'roles'] as const

/** Mapowanie przeniesione 1:1 z thunka. */
export const mapRoleFields = (c: any): RolePermissionModel => ({
  id: c.id,
  name: c.name,
  canViewActivities: c.canViewActivities,
  canViewBillingData: c.canViewBillingData,
  canCreateCompany: c.canCreateCompany,
  canEditCompany: c.canEditCompany,
  canReadDatabaseLogin: c.canReadDatabaseLogin,
  canEditUser: c.canEditUser,
  canRemoveCompany: c.canRemoveCompany,
  canCreateUser: c.canCreateUser,
  canRemoveUser: c.canRemoveUser,
  systemRole: c.systemRole,
  canEditDelegations: c.canEditDelegations,
  canViewDelegations: c.canViewDelegations,
  canImportFiles: c.canImportFiles,
  canAddDriver: c.canAddDriver,
  canViewConfiguration: c.canViewConfiguration,
  isDriver: c.isDriver,
  canViewAlerts: c.canViewAlerts,
  canEditAlerts: c.canEditAlerts,
  canEditActivities: c.canEditActivities,
  canEditBillingData: c.canEditBillingData,
  canEditGpsData: c.canEditGpsData,
  canEditActivityDay: c.canEditActivityDay,
  canGenerateAttestation: c.canGenerateAttestation,
  canGeneratePrintouts: c.canGeneratePrintouts,
  canExportData: c.canExportData,
})

export const fetchRoles = async (): Promise<RolePermissionModel[]> => {
  const response = await API.create().getRoles()
  return (response.content.data as any[]).map(mapRoleFields)
}

export const addRoleRequest = (role: RolePermissionModel) =>
  API.create().addRole(role)

export const editRoleRequest = (roles: RolePermissionModel[]) =>
  API.create().editRole(roles)

export const deleteRolesRequest = (ids: string[]) =>
  API.create().deleteRole(ids)

/** Kształt błędu, którego oczekują komponenty (sprawdzają `.error`). */
export const toActionError = (error: unknown) => ({
  error: (error as any)?.status?.data?.code,
})
